import { render } from "./4.HiTechServices.vue?vue&type=template&id=3c4bf83e&scoped=true"
import script from "./4.HiTechServices.vue?vue&type=script&lang=js"
export * from "./4.HiTechServices.vue?vue&type=script&lang=js"

import "./4.HiTechServices.vue?vue&type=style&index=0&id=3c4bf83e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4bf83e"]])

export default __exports__